import { z } from '@harvestiq/zod';
import { dbApiKeySchema } from './db-api-key';

// multiple api keys
export const getApiKeysRequestSchema = z.object({
  userId: z.string().uuid().optional(),
});
export type GetApiKeysRequest = z.infer<typeof getApiKeysRequestSchema>;

export const getApiKeysResponseSchema = z.object({
  data: z.array(dbApiKeySchema),
});
export type GetApiKeysResponse = z.infer<typeof getApiKeysResponseSchema>;

export const getApiKeysErrorResponseSchema = z.object({
  data: z.tuple([]),
  errors: z.array(z.object({ message: z.string() })),
});

// single api key
export const getApiKeyRequestSchema = z.object({
  apiKeyId: z.string().uuid(),
});
export type GetApiKeyRequest = z.infer<typeof getApiKeyRequestSchema>;

export const getApiKeyResponseSchema = z.object({
  data: z.array(dbApiKeySchema),
});
export type GetApiKeyResponse = z.infer<typeof getApiKeyResponseSchema>;

export const getApiKeyErrorResponseSchema = z.object({
  data: z.tuple([]),
  errors: z.array(z.object({ message: z.string() })),
});
